import React, { useState } from 'react'
import Collapse from '@kunukn/react-collapse'
import propTypes from 'prop-types'
import { Icon } from 'loyal-react'

const HelpItem = ({ question, response }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <React.Fragment>
      <div onClick={() => setIsOpen(!isOpen)} className='col-12 border-color-ui-3 bg-white border px-2 py-3'>
        <p className='pos-relative' role='button' aria-expanded={isOpen}>
          <strong>{question}</strong>
          <Icon iconName={isOpen ? 'icon_up' : 'icon_down'} className='pos-absolute r-0 icon-sm' />
        </p>
      </div>
      <Collapse
        isOpen={isOpen}
        className={'w-100 app__collapse app__collapse--gradient ' + (isOpen ? 'app__collapse--active' : '')}
        transition='height 800ms cubic-bezier(0.4, 0, 0.2, 1)'
        aria-hidden={isOpen ? 'false' : 'true'}
        elementType='article'
        render={collapseState => (
          <React.Fragment>
            <div className='bg-ui-4 border-color-ui-3 border p-2'>
              <p className='mb-2 text-p'>
                { response }
              </p>
            </div>
          </React.Fragment>
        )}
      />
    </React.Fragment>
  )
}

HelpItem.propTypes = {
  question: propTypes.string,
  response: propTypes.string
}
export default HelpItem



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashbackDms/Questions/HelpItem.js